import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MyMultiSelect,
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea
} from "../Lib/componentLibrarys";

export const FormNhap = ({
  values,
  errors,
  setFieldValue,
  sanPhamList,
  vungSanXuatList,
  coSoCheBienList,
  coSoPhanPhoiList,
  coSoSanXuatList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="tenLoHang">
            {({ field }) => (
              <MyTextField
                required
                label="Tên lô hàng:"
                placeholder="Nhập..."
                errors={errors?.tenLoHang}
                helperText={errors?.tenLoHang}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Sản phẩm:"
            placeholder="Chọn..."
            value={values?.sanPham}
            options={sanPhamList || []}
            name="tenSanPham"
            onChange={(event, value) => {
              setFieldValue(`sanPham`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Vùng sản xuất:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`vungSanXuats`, value);
            }}
            value={values?.vungSanXuats || []}
            options={vungSanXuatList || []}
            name="tenVungSanXuat"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Cơ sở sản xuất:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`coSoSanXuats`, value);
            }}
            value={values?.coSoSanXuats || []}
            options={coSoSanXuatList || []}
            name="tenCoSoSanXuat"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Cơ sở chế biến:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`coSoCheBiens`, value);
            }}
            value={values?.coSoCheBiens || []}
            options={coSoCheBienList || []}
            name="tenCoSoCheBien"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Cơ sở phân phối:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`coSoPhanPhois`, value);
            }}
            value={values?.coSoPhanPhois || []}
            options={coSoPhanPhoiList || []}
            name="tenCoSoPhanPhoi"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            label="Ngày xuất bán:"
            placeholder="Chọn..."
            value={values?.ngayXuatBan}
            onChange={value => {
              setFieldValue(`ngayXuatBan`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="hanSuDung">
            {({ field }) => (
              <MyTextField
                label="Hạn sử dụng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="sanLuong">
            {({ field }) => (
              <MyTextField
                label="Sản lượng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.trangThai}
                onChange={(event, value) => {
                  setFieldValue("trangThai", value);
                }}
              />
            }
            label="Trạng thái"
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};
